import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { BannerSize, BannerType } from './banner.model';

@Component({
  selector: 'flow-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent implements AfterViewInit {
  @ViewChild('ticker') ticker: any;
  @Input() type: BannerType;
  @Input() size: BannerSize;
  @Input() text: string;
  @Input() canClose = false;
  @Input() id: number;
  BannerSize = BannerSize;
  show = true;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngAfterViewInit() {
    const tickerContainer = this.ticker.nativeElement;
    const tickerText = tickerContainer.children[0];

    const tickerContainerWidth = tickerContainer.offsetWidth;
    const tickerTextWidth = tickerText.offsetWidth;

    if (tickerTextWidth >= tickerContainerWidth) {
      this.renderer.setStyle(tickerText, 'animation', 'none'); // Remove temporary inline style
      this.renderer.addClass(tickerText, 'animate-marquee');
    }
  }

  get typeClasses(): string {
    const styles = {
      success: 'fl-alert-success',
      error: 'fl-alert-error',
      info: 'fl-alert-info',
    };

    const size = {
      sm: 'h-7',
      md: 'h-9',
    };

    const classes = `${styles[this.type]} ${size[this.size]}`;

    return classes;
  }

  closeBanner() {
    this.show = false;
  }
}
